<template>
  <div class="login-modal">
    <Modal ref="loginModal">
      <div class="login-modal__login">
        <LoginRegisterForm />
      </div>
    </Modal>
  </div>
</template>
<script>
import LoginRegisterForm from "@/components/form/LoginRegisterForm.vue";
import Modal from "@/components/ui/Modal.vue";
import { EventBus } from "@/mixins/event-bus";

export default {
  components: { Modal, LoginRegisterForm },
  mounted() {
    EventBus.$on("openLoginModal", () => {
      this.open();
    });
    EventBus.$on("closeLoginModal", () => {
      this.close();
    });
  },
  methods: {
    open() {
      this.$refs.loginModal.open();
    },
    close() {
      this.$refs.loginModal.close();
    }
  }
};
</script>
<style lang="scss">
.login-modal {
  text-align: center;

  .modal__wrapper {
    max-width: 500px;
    width: 90%;
  }
}
</style>
